<script >
import BodyTeleport from './BodyTeleport.vue';
import { computed, defineAsyncComponent } from 'vue-demi';
import { CHILD_TYPE, LAYOUT } from '../common/enum';
const FlowContainer = defineAsyncComponent(() => Promise.resolve(require('@futuweb/fego-render')?.plugins.ComplexComp.Container.Flow));
// 容器相关
const {
  plugins: {
    ComplexComp
  }
} = require('@futuweb/fego-render');
import LogoImg from '../children/logo-img/render/index.vue';
const __sfc_main = {
  mixins: [ComplexComp.Inner.Parent.Mixins({
    [CHILD_TYPE]: LogoImg
  })]
};
__sfc_main.props = ['tpl', 'fixedTop', 'layout'];
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const logoChild = computed(() => props.tpl.children.filter(item => item.type === CHILD_TYPE));
  const otherChildren = computed(() => props.tpl.children.filter(item => item.type !== CHILD_TYPE));

  // 类 样式
  const {
    usePageType,
    useZIndex
  } = require('@fegobull/webapi').use;
  const {
    rem: {
      parseStyle
    }
  } = require('@futuweb/fego-bridge');
  const {
    isPC
  } = usePageType();
  const wrapperStyle = {
    ...parseStyle(props.tpl.style),
    zIndex: useZIndex()
  };

  // 是否有官网头部
  const withCommonHeader = window?._params?.payload?.officialTmpl?.getHeader;
  return {
    LAYOUT,
    logoChild,
    otherChildren,
    isPC,
    wrapperStyle,
    withCommonHeader
  };
};
__sfc_main.components = Object.assign({
  BodyTeleport,
  FlowContainer
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <div
        v-if="!withCommonHeader"
        :class="[
            'top-container-wrapper',
            {
                pc: isPC,
                'layout-cover': fixedTop && layout === LAYOUT.COVER
            }
        ]"
    >
        <body-teleport
            :needTeleport="fixedTop"
            :class="[
                'top-container',
                {
                    pc: isPC,
                    fixed: fixedTop
                }
            ]"
            :style="wrapperStyle"
        >
            <!-- 子项 -->
            <inner-children-renderer v-if="logoChild[0]" class="top-container__logo" :children="logoChild[0]" />
            <flow-container :children="otherChildren" class="right-flow-container"></flow-container>
        </body-teleport>
    </div>
</template>
<style lang="less" scoped>
@import '../render/index.less';
</style>
